import { DiagramComponent } from '../core/DiagramComponent';
import type { DiagramConfig, Variables, JXGBoard } from '../types/interfaces';

/**
 * Diagram container component
 * The root component that contains all other components
 */
export class Diagram extends DiagramComponent<DiagramConfig> {
  constructor(config: DiagramConfig, board: JXGBoard, parentState: Variables = {}) {
    super(config, board, parentState);
  }

  render(): void {
    // The diagram itself doesn't render JSXGraph elements
    // It's just a container for child components
    
    // Render all children
    this.children.forEach(child => {
      child.render();
    });
  }

  getSpecificity(): number {
    return 1; // Lowest priority - diagram is the background container
  }
}
